export const links = {
  accountOverview:
    process.env.REACT_APP_SELF_SERVICE_URL + "/my-racq/account-overview",
  roadside: process.env.REACT_APP_SELF_SERVICE_URL + "/my-racq/roadside",
  insurance: process.env.REACT_APP_SELF_SERVICE_URL + "/my-racq/insurance",
  bank: process.env.REACT_APP_SELF_SERVICE_URL + "/my-racq/bank",
  profile: process.env.REACT_APP_SELF_SERVICE_URL + "/my-racq/profile",
  benefits: process.env.REACT_APP_SELF_SERVICE_URL + "/my-racq/member-benefits",
  privacy: process.env.REACT_APP_HOME_URL + "/privacy",
  insurancePrivacy:
    process.env.REACT_APP_HOME_URL + "/privacy/insurance-collection-notice",
};

export const menu = [
  {
    label: "Home",
    icon:
      process.env.REACT_APP_HOME_URL +
      "/-/media/project/racqformsgroup/racq/menu-icons/home.svg",
    alt: "home icon",
    link: links.accountOverview,
  },
  {
    label: "Roadside assistance",
    icon:
      process.env.REACT_APP_HOME_URL +
      "/-/media/project/racqformsgroup/racq/menu-icons/roadside.svg",
    alt: "roadside icon",
    link: links.roadside,
  },
  {
    label: "Insurance",
    icon:
      process.env.REACT_APP_HOME_URL +
      "/-/media/project/racqformsgroup/racq/menu-icons/insurance.svg",
    alt: "insurance icon",
    link: links.insurance,
  },
  {
    label: "Bank",
    icon:
      process.env.REACT_APP_HOME_URL +
      "/-/media/project/racqformsgroup/racq/menu-icons/home.svg",
    alt: "home icon",
    link: links.bank,
  },
  {
    label: "Profile",
    icon:
      process.env.REACT_APP_HOME_URL +
      "/-/media/project/racqformsgroup/racq/menu-icons/profile.svg",
    alt: "profile icon",
    link: links.profile,
  },
  {
    label: "Member benefits",
    icon:
      process.env.REACT_APP_HOME_URL +
      "/-/media/project/racqformsgroup/racq/menu-icons/benefits.svg",
    alt: "member icon",
    link: links.benefits,
  },
];

export const sidebarFooterLinks = [
  {
    label: "Help and support",
    link: process.env.REACT_APP_HOME_URL + "/help-contact",
  },
  {
    label: "FAQs",
    link: process.env.REACT_APP_HOME_URL + "/help-contact",
  },
  {
    label: "Locate us",
    link: process.env.REACT_APP_HOME_URL + "/help-contact/find-a-store",
  },
  {
    label: "Get the app",
    link:
      process.env.REACT_APP_HOME_URL + "/help-contact/racq-apps#fairFuelApp",
  },
];

export const pageFooterLinks = [
  {
    label: "Support",
    link: process.env.REACT_APP_HOME_URL + "/help-contact",
  },
  {
    label: "Corporate",
    link: process.env.REACT_APP_HOME_URL + "/about-us/corporate",
  },
  {
    label: "Legal",
    link: process.env.REACT_APP_HOME_URL + "/legal",
  },
  {
    label: "Privacy Statement",
    link: process.env.REACT_APP_HOME_URL + "/privacy",
  },
];
